import HelloWorld from '@/components/HelloWorld'
import {
	Login,
	User,
	Content,
	Dashboard,
	Order,
} from '../views/'
import {
	Home
} from '../layout/'


export default [{
		path: '/',
		name: 'cms',
		redirect: '/login'
	},
	{
		path: '/login',
		name: '登录',
		hidden: true,
		meta: {
			noRequireAuth: true,
			application: ['notInTab', 'notInAuth']
		},
		component: Login
	},
	{
		path: '/home',
		name: 'home',
		component: Home,
		meta: {},
		children: [{
				path: 'dashboard',
				name: '控制面板',
				component: Dashboard.Dashboard
			},

			{
				path: 'adminLists',
				name: '管理员列表',
				component: User.AdminLists
			},
			{
				path: 'role',
				name: '角色管理',
				component: User.Role
			},
			{
				path: 'access',
				name: '权限管理',
				component: User.Access
			},
			{
				path: 'config',
				name: '项目配置',
				component: User.Config
			},
			{
				path: 'user',
				name: '用户管理',
				component: User.User
			},
			{
				path: 'company',
				name: '企业用户',
				component: User.Company
			},
			{
				path: 'thirdApp',
				name: '配置列表',
				component: User.ThirdApp
			},

			{
				path: 'label',
				name: '菜单管理',
				component: Content.Label
			},
			{
				path: 'article',
				name: '文章管理',
				component: Content.ArticleLists
			},
			{
				path: 'art',
				name: '首页内容',
				component: Content.Art
			},
			{
				path: 'protocol',
				name: '隐私协议',
				component: Content.Protocol
			},
			{
				path: 'message',
				name: '开票管理',
				component: Content.Message
			},
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/mainRouter.js